<script>
export default {
    name: 'IconPrice',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-price"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M36 8l16 16v32H12V24L28 8h8zm-2.047 18c-1.822 0-3.513.343-5.073 1.028a11.055 11.055 0 00-3.974 2.917 11.516 11.516 0 00-2.356 4.375H19v2.785h3.079a7.91 7.91 0 00-.031.704V38c0 .398.01.696.03.895H19v2.785h3.55a11.516 11.516 0 002.356 4.375 11.055 11.055 0 003.974 2.917c1.56.685 3.25 1.028 5.073 1.028 1.906 0 3.628-.354 5.167-1.06A10.282 10.282 0 0043 45.855l-3.236-3.182c-1.507 1.834-3.36 2.751-5.56 2.751-1.382 0-2.618-.331-3.707-.994a6.617 6.617 0 01-2.513-2.751h7.948v-2.785h-8.733a9.323 9.323 0 01-.031-.895c0-.398.01-.696.031-.895h8.733V34.32h-7.948a6.617 6.617 0 012.513-2.75c1.09-.664 2.325-.995 3.707-.995 2.178 0 4.032.906 5.56 2.718L43 30.11a10.415 10.415 0 00-3.88-3.05c-1.539-.705-3.26-1.06-5.167-1.06zM32 19a3 3 0 100-6 3 3 0 000 6z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
